import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ConsultaRESTBaseService } from './consulta-restbase.service';
import { ItemEstrutura } from '../components/shared/item-estrutura';
import { AlertMessageService } from '@sigepe/sigepe-template';

export interface ExcecaoCargo extends ItemEstrutura {
    grupoCargo: string;
    codigoCargo: string;
    descricao: string;
    codGrupoCargo: string;
    nome: string;
}

export interface ExcecaoFuncao extends ItemEstrutura {
    sigla: string;
    nivel: number;
    descricao: string;
}

export interface FuncaoNivel extends ItemEstrutura {
    sigla: string;
    nivel: number;
    funcaoFormatada: string;
}

export interface Orgao extends ItemEstrutura {
    codigoNaturezaJuridica: number;
    codigoNomeFormatado: string;
    codigoNomeSiglaFormatado: string;
    codigoSiorg: number;
    sigla: string;
}

export interface Upag extends ItemEstrutura {
    orgao: Orgao;
}

export interface Uorg extends ItemEstrutura {
    orgao: Orgao;
    upag: Upag;
}

@Injectable({
    providedIn: 'root'
})
/**
 * Serviços internos de consulta de dados do SIAPE do Férias
 */
export class ConsultaSiapeService extends ConsultaRESTBaseService {
    constructor(alertaMsgService: AlertMessageService, http: HttpClient) {
        super(alertaMsgService, http);
    }

    public listCargosExcecao(): Observable<ExcecaoCargo[]> {
        return super.get('/cargo/list');
    }

    public listFuncoesExcecao(): Observable<ExcecaoFuncao[]> {
        return super.get('/funcao/list');
    }

    public listFuncoesNivel(): Observable<FuncaoNivel[]> {
        return super.get('/sigepe/validacao-cadastral/siape/util/funcao/funcoes');
    }

    public listOrgaos(): Observable<Orgao[]> {
        return super.get('/siape-servico-orgao/orgaos');

        /*return of([
      {  
        id: 1,
        descricao: "descricao",
        codigoNaturezaJuridica: 1,
        codigoNomeFormatado: "nome",
        codigoNomeSiglaFormatado: "sigla",
        codigoSiorg: 1,
        sigla: ""  
      },{  
        id: 2,
        descricao: "descricao 2",
        codigoNaturezaJuridica: 2,
        codigoNomeFormatado: "nome 2",
        codigoNomeSiglaFormatado: "sigla 2",
        codigoSiorg: 2,
        sigla: ""  
      }
    ]);*/
    }

    public listUpags(codigoOrgao: number): Observable<Upag[]> {
        return super.get(`/siape-servico-upag/upags/${codigoOrgao}`);
    }

    public listUorgs(codigoOrgao: number, codigoUpag: number): Observable<Uorg[]> {
        return super.get(`/siape-servico-uorg/uorgs/${codigoOrgao}/${codigoUpag}`);
    }

    public getUorg(codigoOrgao: number, codigoUpag: number, codigoUorg: number): Observable<Uorg> {
        return super.get(`/get/orgao/${codigoOrgao}/upag/${codigoUpag}/uorg/${codigoUorg}`);
    }
}
